import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
const CloseButton = ({ onEndConversationClick, isUserHost }) => {
    const { t } = useTranslation();
    return (React.createElement(Tooltip, { title: isUserHost ? t('header.quitConversation') : t('header.exitConversation'), "aria-label": "quit-conversation", enterDelay: 300, leaveDelay: 200 },
        React.createElement(Fab, { size: "small", style: {
                width: 56,
                height: 56,
                backgroundColor: 'rgb(255, 0, 0, 1)',
                color: 'white',
            }, onClick: onEndConversationClick },
            React.createElement(CloseIcon, null))));
};
const mapStateToProps = ({ scribeConversation: { status }, scribeSession: { captioner } }) => {
    var _a;
    return ({
        isUserHost: ((_a = status.host) === null || _a === void 0 ? void 0 : _a.avaId) === captioner.avaId,
    });
};
export default connect(mapStateToProps)(CloseButton);
